import { TripHeader } from "../services/backend/naar-api-client";

export type TripHeaderIconClass = 'download-outline' | 'cloud-download-outline' | 'cloud-offline-outline';

export class TripHeaderData extends TripHeader {
	public icon?: TripHeaderIconClass;

	/** Get the title of the trip header in the format "id - name" */
	get title() {
		return `${this.id} - ${this.name}`;
	}

	constructor(id: number, name: string, icon: TripHeaderIconClass = null) {
		super();
		this.id = id;
		this.name = name;
		this.icon = icon;
	}

	// public static fromTripHeader(trip: TripHeader): TripHeadermodal {
	// 	return new TripHeadermodal(trip);
	// }
}